export const articlesKeys = {
    articleListSearch: "article-list-search",
    menuItems: "menu-items",
    allArticles: "all-articles",
    mainArticle: "main-article",
    articleVersion: "article-version",
    articleVersions: "article-versions",
    articleRegistries: "article-registries"
}